import { GroupsTab } from './groupsTab';

export const myGroupsTabComponent = {
  template: require('./groupsTab.html'),
  controllerAs: 'ctrl',
  controller: GroupsTab,
};
